/**
 * Created by zj on 2017/7/29.
 */
import Component from "../../../../lib/component";
import template from './calendar.week.html';
import './calendar.week.scss';

import TableGrid from '../calendar.subcomponent/calendar.table.grid/calendar.table.grid';
import CalendarTableHeader from '../calendar.subcomponent/calendar.table.header/calendar.table.header';
import Mediator from '../../../../lib/mediator';

let config = {
    template: template,
    data: {
        weekListHead: [
            {itemTitle:'星期日'},
            {itemTitle:'星期一'},
            {itemTitle:'星期二'},
            {itemTitle:'星期三'},
            {itemTitle:'星期四'},
            {itemTitle:'星期五'},
            {itemTitle:'星期六'},
        ],
        weekData: [],
    },
    actions: {
    },
    binds:[
        //拖动进入.task-item排序
        {
            event:'click',
            selector:'.date-head',
            callback:function(context){
                Mediator.emit('Calendar: changeMainView', {calendarContent: 'schedule',date: this.el.find(context)[0].innerText});
            }
        }
    ],
    afterRender: function() {
        this.el.css({"height":"100%","width":"100%"});
        this.append(new CalendarTableHeader({data:{headData: this.data.weekListHead, type:'week'}}), this.el.find('.week-head'));
        this.data.weekData.forEach(item => {
            this.append(new TableGrid({data:{bodyData: item, type: 'week'}}), this.el.find('.week-body'));
        });
    }
};

// class CalendarWeek extends Component {
//     constructor(data, newconfig = {}) {
//         [config.data.weekListHead, config.data.weekData] = data;
//         // super(config);
//         super($.extend(true ,{}, config, newconfig));
//     }
// }
//
// export default CalendarWeek;
let CalendarWeek = Component.extend(config);

export default CalendarWeek;


// WEBPACK FOOTER //
// app/components/calendar/calendar.main/calendar.week/calendar.week.js